import React, { useState } from 'react'
import './Profile.css'
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import ProfileTabs from '../ProfileTabs/ProfileTabs';

const Profile = () => {
  return (
    <div className='outerDiv'>
      <div style={{ display: 'flex' }}>
        <h1> Profiles </h1>
        <DocumentScannerIcon sx={{ fontSize: 40, color: 'blue', marginTop: '20px', marginLeft: '7px' }}/>
      </div>
      <div>
        Select a profile from list below
      </div>
      <div>
        <ProfileTabs />
      </div>
      
    </div>
  )
}

export default Profile